<template>
  <div class="poster-list">
    <div class="page-actions">
      <el-table :data="poserlist">
        <el-table-column prop="coinType" label="币种"></el-table-column>
        <el-table-column prop="amount" label="所需持仓量"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row.coinType)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <update-list :onePoster="chooseOne" @refresh="refreshList" />
  </div>
</template>
<script>
import Upload from "components/upload";
import { mapActions, mapState, mapMutations } from "vuex";
import updateList from "../update";

export default {
  data() {
    return {
      chooseOne: {}
    };
  },
  computed: {
    ...mapState("chatroom", ["poserlist"])
  },
  methods: {
    ...mapActions("chatroom", ["list", "remove"]),
    ...mapMutations("chatroom", ["setupdatePosterDialog"]),
    refreshList() {
      this.list();
    },
    handleEdit(item) {
      this.chooseOne = item;
      this.setupdatePosterDialog(true);
    },
    handleRemove(value) {
      this.$confirm("确认要删除该配置吗？", "提示", { type: "warning" }).then(
        () => {
          this.remove({coinType:value}).then(() => {
            this.$message.success("删除成功！");
            this.$emit("refresh");
          });
        }
      );
    }
  },
  mounted() {},
  components: {
    updateList
  }
};
</script>
<style lang="less">
.imglist {
  max-height: 100px;
}
</style>
